/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import mobile from 'is-mobile';
import moment from 'moment';
import classnames from 'classnames';
import seedrandom from 'seedrandom';
import { connect } from 'react-redux';
import { ClickStars } from 'module-tsl-ui-elements';
import {
  setUserReview,
  cancelUserReview,
  submitReview,
  removeRecentReview,
  setReviewDisplayState,
  setIsProfan,
} from '../../../modules/ReviewsModule';
import Confetti from './Confetti';
import { setupResource, emitReview, emitRating } from '../../../modules/Mz';
import getFormattedPrice from '../../../utils/price-util';

const readCookie = (k) => (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2];
const { Handle } = Slider;
const ResourceCard = ({ cardLink, title, description, author, cardStyle, imageUrl, theme = 1, type }) => {
  const shorten = (text, limit) => {
    if (!text) {
      return '';
    }
    if (text.length > limit) {
      return `${text.substr(0, text.lastIndexOf(' ', limit))}...`;
    }
    return text;
  };

  const themeColor = `resource-card-color-${theme}`;
  const isMobile = cardStyle !== 'desktop';
  const resourceTitle = isMobile ? shorten(title, 65) : title;
  const resourceDescription = isMobile ? shorten(description, 70) : description;

  const cardBodyCssClass = classnames({
    'resource-card__body': true,
    'resource-card__body--no-border resource-card__body--no-bottom-radius': cardStyle !== 'desktop',
    'resource-card__body--sm': cardStyle === 'sm',
    'resource-card__body--desktop': cardStyle === 'desktop',
    'resource-card__body--no-bottom-radius': cardStyle === 'desktop',
  }, themeColor);
  const themedCardLink = `${cardLink}${cardLink.indexOf('?') > -1 ? '&' : '?'}theme=${theme}`;
  return (
    <div className="resource-card">
      <a data-mz data-module={type || null} className="link link--inherit-color link--nounderline" href={themedCardLink}>
        <div className={cardBodyCssClass}>
          {cardStyle === 'desktop'
            && <div className={`resource-card__image-container ${themeColor}`}>
              {imageUrl && <img role="presentation" className="resource-card__image" src={imageUrl} />}
            </div>}
          <div className="resource-card__text-container">
            <h4 className="resource-card__headline">{resourceTitle}</h4>
            {description
              && <p className="resource-card__description" dangerouslySetInnerHTML={{ __html: resourceDescription }}></p>}
            <p className="resource-card__author">{author}</p>
          </div>
        </div>
      </a>
    </div>
  );
};

ResourceCard.propTypes = {
  cardLink: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  author: PropTypes.string,
  cardStyle: PropTypes.string,
  imageUrl: PropTypes.string,
  theme: PropTypes.number,
  type: PropTypes.string,
};

@connect((state) => ({
  reviewDisplayStates: state.reviewsModule.reviewDisplayStates,
  reviewReasons: state.reviewsModule.reviewReasons,
  userReviews: state.reviewsModule.userReviews,
  isReviewMessageProfan: state.reviewsModule.isProfan,
}), {
  setUserReview,
  cancelUserReview,
  submitReview,
  setReviewDisplayState,
  removeRecentReview,
  emitReview,
  emitRating,
  setupResource,
  setIsProfan,
})
export default class ReviewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPosting: false,
      ratingSelectValue: null,
      reasons: {},
      reviewText: '',
      reviewSubmited: false,
      ratingSaved: false,
      showReviewDialog: false,
      showChoiceDialog: false,
      lowReviewNoComment: false,
    };
  }

  onRatingClicked(rating) {
    const { resource } = this.props;
    this.props.setUserReview({
      id: resource._id,
      rating,
    });
    this.onRatingSubmit(rating);
  }

  handleSlider(props) {
    const { value, ...restProps } = props;
    const ratingText = [
      'Drag me',
      'Very poor',
      'Poor',
      'OK',
      'Good',
      'Excellent',
    ][value];
    return (
      <Handle {...restProps}>
        <div className={`rating-text rating-text__${value}`}>
          {ratingText}
        </div>
        <i className={`rating__icon icon icon-star ${value === 0 ? 'icon-light-gray' : 'icon-yellow'}`}></i>
        <div className="rating-number">
          {value}
        </div>
      </Handle>
    );
  }

  handleReasonChange(reasonId) {
    const { reasons } = this.state;
    this.setState({ reasons: { ...reasons, [reasonId]: !reasons[reasonId] } }, () => {
      this.onSubmitClick(true);
    });
  }

  handleReviewChange(value) {
    this.setState({ reviewText: value });
  }

  selectReviewMode(event, isPositive) {
    if (this.state.reviewSubmited) {
      event.preventDefault();
      return;
    }

    this.setState({ ratingSelectValue: isPositive, showReviewDialog: isPositive, showChoiceDialog: !isPositive, reasons: {}, reviewText: '', ratingSaved: false }, () => {
      this.onSubmitClick(true);
    });
  }

  onSubmitClick(onlyRatingSubmited = false) {
    const { resource } = this.props;
    const { ratingSelectValue, reasons, reviewText } = this.state;
    const userId = readCookie('TESCookieUser') || readCookie('TESReviewUser');
    const rating = ratingSelectValue ? 5 : 1;
    const comment = reviewText;
    const validReasons = Object.keys(reasons).filter(key => reasons[key]);

    const reviewToSubmit = {
      asset: { id: resource._id, type: 'resource', authorId: resource.authorId },
      comment,
      rating,
      reasons: validReasons,
      timestamp: new Date(),
    };

    if (comment || validReasons.length) {
      this.props.emitReview({
        eventTitle: 'thumbs-review',
        module: { name: 'review' },
        payload: {
          comment: !!comment,
          reasons: validReasons,
          'asset.id': resource._id,
        },
      });
    }

    if (!this.state.ratingSaved) {
      this.props.emitRating({
        eventTitle: 'thumbs-rating',
        module: { name: 'review' },
        payload: {
          rating: ratingSelectValue ? 1 : -1,
          'asset.id': resource._id,
        },
      });
    }

    this.props.submitReview({
      review: reviewToSubmit,
      userId,
      resource,
      refreshResources: false,
      whenDone: () => {
        if (onlyRatingSubmited) {
          this.setState({ ratingSaved: true });
        } else {
          this.setState({ reviewSubmited: true });
        }
      },
    });
  }

  onSkipClick() {
    this.setState({ reviewSubmited: true });
  }

  resetReviewState() {
    this.setState({ showReviewDialog: false, showChoiceDialog: true });
  }

  renderReviewReasons(resource) {
    const type = this.state.ratingSelectValue ? 'positive' : 'negative';
    const reasons = this.props.reviewReasons.filter(reason => reason.type === type);

    return reasons.map(reason =>
      <div className={`review-reason-wrapper ${type}-reason`} key={reason.id}>
        <input type="checkbox" id={`${resource._id}-${reason.id}`} checked={!!this.state.reasons[reason.id]} onChange={() => { this.handleReasonChange(reason.id); }} />
        <label htmlFor={`${resource._id}-${reason.id}`}>
          {reason.text}
          <i className={classnames({
            'icon icon-thumb-up': this.state.ratingSelectValue,
            'icon icon-thumb-down': !this.state.ratingSelectValue,
            'icon-lighter-gray': !this.state.reasons[reason.id],
            'icon-light-green': !!this.state.reasons[reason.id] && this.state.ratingSelectValue,
            'icon-light-red': !!this.state.reasons[reason.id] && !this.state.ratingSelectValue,
          })}>
          </i>
        </label>
      </div>);
  }

  onCommentChange(comment) {
    const { resource } = this.props;
    if (!comment.trim()) {
      this.setState({ lowReviewNoComment: true });
      this.props.setReviewDisplayState(resource._id, 'lowRateNoComment');
    } else {
      this.setState({ lowReviewNoComment: false });
    }
    this.props.setUserReview({
      id: resource._id,
      comment,
      timestamp: new Date(),
    });
  }

  onPostReview() {
    const { resource, userReviews } = this.props;
    const resourceId = resource._id;
    const { comment, rating } = userReviews[resourceId];
    this.props.setIsProfan(comment);

    const reviewToSubmit = {
      asset: { id: resourceId, type: 'resource', authorId: resource.authorId },
      comment,
      rating,
      timestamp: new Date(),
    };

    const userId = readCookie('TESCookieUser') || readCookie('TESReviewUser');

    this.setState({ isPosting: true });

    this.props.emitReview({
      eventTitle: 'review',
      module: { name: 'review' },
      payload: reviewToSubmit,
    });

    this.props.submitReview({
      review: reviewToSubmit,
      userId,
      resource,
      refreshResources: true,
      whenDone: (isProfan = false) => {
        if (!isProfan) this.props.setReviewDisplayState(resourceId, 'reviewSaved');
        return this.setState({ isPosting: false });
      },
    });
  }

  onRatingSubmit(newRating) {
    const { resource, review } = this.props;
    const rating = newRating || review.rating;
    const lowRate = [1, 2].indexOf(rating) !== -1;
    const comment = (review && review.comment) ? review.comment.trim() : '';
    const reviewToSubmit = {
      asset: { id: resource._id, type: 'resource', authorId: resource.authorId },
      comment,
      rating,
      timestamp: new Date(),
    };
    const currentDisplayState = lowRate && !reviewToSubmit.comment ? 'lowRateNoComment' : 'regularReview';

    if (lowRate && !reviewToSubmit.comment) {
      this.setState({ lowReviewNoComment: true });
    } else {
      this.setState({ lowReviewNoComment: false });
    }

    this.props.setReviewDisplayState(resource._id, currentDisplayState);

    this.props.setupResource(resource, 'resource.dash-reviews');
    if (comment) {
      this.props.emitReview({
        eventTitle: 'review',
        module: { name: 'review' },
        payload: { 'asset.id': resource._id },
      });
    }

    this.props.emitRating({
      eventTitle: 'rating',
      module: { name: 'review' },
      payload: { rating, 'asset.id': resource._id },
    });
  }

  isTestGroup() {
    return window.TES.isTestGroup === 'true';
  }

  onFormCancel() {
    const { review } = this.props;
    this.props.cancelUserReview(review);
  }

  onDismiss(resourceId) {
    this.props.removeRecentReview(resourceId);
  }

  renderDateAndPrice(dispStatus, resource, price) {
    if (dispStatus === 'reviewSaved') {
      return null;
    } if (resource.purchaseDate) {
      return (<div className="top-info-bar"><span className="grey">You purchased on:</span> <span className="text--bold">{moment(resource.purchaseDate).format('DD MMM YYYY')}</span><span className="margin-left-right-sm">|</span>Price: <span className="text--bold">{price}</span></div>);
    }

    return (<div className="top-info-bar"><span className="grey">You downloaded on:</span> <span className="text--bold">{moment(resource.date).format('DD MMM YYYY')}</span></div>);
  }

  renderRating(dispStatus, isTestGroup, isMobile, resource, review) {
    if (dispStatus === 'reviewSaved') {
      return null;
    } if (isTestGroup) {
      return (
        <div className={classnames({ 'mobile-view': isMobile }, 'resource-rating-wrapper')}>
          <div className={classnames({ 'mobile-view': isMobile }, 'resource-rating')}>
            <div className="resource-rating-question">
              <h4>Would you recommend this resource?</h4>
            </div>
            {this.state.ratingSaved
              ? <div className="resource-rating-saved">
                <h5>Rating saved.</h5>
              </div>
              : null}
            <div className="rating-select-wrapper">
              <input type="radio" name={`rating-select-${resource._id}`} className="rating-select-input-yes" id={`rating-select-${resource._id}-yes`}
                checked={this.state.ratingSelectValue === true}
                onChange={(e) => { this.selectReviewMode(e, true); }}
              />
              <label htmlFor={`rating-select-${resource._id}-yes`} className={classnames({ 'rating-select-disabled': this.state.ratingSelectValue === false }, 'rating-select', 'rating-select-yes')}>
                <i className={classnames({ 'icon-light-green': this.state.ratingSelectValue !== false, 'icon-lighter-gray': this.state.ratingSelectValue === false }, 'icon icon-thumb-up')}></i>
                Yes
              </label>

              <input type="radio" name={`rating-select-${resource._id}`} className="rating-select-input-no" id={`rating-select-${resource._id}-no`}
                checked={this.state.ratingSelectValue === false}
                onChange={(e) => { this.selectReviewMode(e, false); }}
              />
              <label htmlFor={`rating-select-${resource._id}-no`} className={classnames({ 'rating-select-disabled': this.state.ratingSelectValue === true }, 'rating-select', 'rating-select-no')}>
                <i className={classnames({ 'icon-light-red': this.state.ratingSelectValue !== true, 'icon-lighter-gray': this.state.ratingSelectValue === true }, 'icon icon-thumb-down')}></i>
                No
              </label>
            </div>
          </div>
        </div>
      );
    } if (isMobile) {
      return (
        <div className="tes-rc-slider"><Slider
          min={0}
          max={5}
          defaultValue={(review && review.rating) || 0}
          handle={this.handleSlider.bind(this)}
          onAfterChange={(starIndex) => starIndex && this.onRatingClicked(starIndex)}
          index={resource._id}
        /></div>
      );
    }
    return (
      <ClickStars
        starIndex={(review && review.rating) || 0}
        onRatingClicked={(starIndex) => this.onRatingClicked(starIndex)}
      />
    );
  }

  render() {
    const { resource, review, error, reviewDisplayStates, isReviewMessageProfan } = this.props;
    const price = getFormattedPrice(resource);
    const cardStyle = mobile() ? 'mobile' : 'desktop';
    const rng = seedrandom(resource._id);
    const theme = Math.floor(rng() * (8 - 1)) + 1;
    const dispStatus = (reviewDisplayStates[resource._id]) ? reviewDisplayStates[resource._id] : 'default';
    return <div key={resource._id} className="user-dashboard-reviews-resource">
      {dispStatus === 'reviewSaved' ? <div className="reviewed__message">
        {resource.played === true ? null : <Confetti resource={resource} />}
        <div className="thanks__for__review">
          <h3>Thank you!</h3>
          <div>
            <p>Your expert reviews make a huge difference to the way teachers find and use resources on Tes. Thanks for being a valued part of our community!</p>
          </div>
          <div>
            <button className="review-submit tes-btn link--colored" onClick={() => { this.onDismiss(resource._id); }}>Dismiss</button>
          </div>
        </div>
      </div> : null}

      {this.renderDateAndPrice(dispStatus, resource, price)}

      {dispStatus === 'reviewSaved' ? null : <div className={classnames({ 'resource-card-wrapper': true, 'AB-tested': this.isTestGroup(), 'mobile-view': mobile() })}>
        <ResourceCard
          cardLink={resource.url}
          title={resource.title}
          description={resource.description}
          authorLink={`/member/${resource.authorUsername}`}
          author={resource.authorUsername}
          cardStyle={cardStyle}
          theme={theme}
          imageUrl={resource.thumbnailUrl}
        />
      </div>
      }

      {error ? <span className="ResourceReviewsAdd-noRatingError">
        <i className="icon icon-exclamation-triangle icon-red margin-right-xxs"></i>
        {error}
      </span> : null
      }

      {this.renderRating(dispStatus, this.isTestGroup(), mobile(), resource, review)}

      {dispStatus === 'lowRateNoComment'
        ? <div>
          <p className="low-rating-notification">
            If you’re leaving a poor rating for technical / offensive / inappropriate / copyright issues please complete
            {' '}
            <a
              href="https://tes_global.formstack.com/forms/resources_report_a_problem"
              target="blank"
              rel="noopener noreferrer"
              className="link--colored link-blue"
            >
              this form
            </a>
            {' '}
            so we can address the problem immediately.
          </p>
          <p className="low-rating-notification">For any other reasons please let the author know so they can improve their content.</p>
        </div> : null}

      {dispStatus !== 'reviewSaved' && dispStatus !== 'default' ? <div className="ResourceReviewsAdd-comment">
        <div className="heading heading--md">Would you like to leave a review?</div>
        {
          isReviewMessageProfan
          && <div className="review-message-error">You are unable to publish this review as it contains offensive language. Please reflect on your review and change any words that may be offensive. Please contact help@tes.com if you wish to discuss this further.</div>
        }
        <textarea
          name="reviewText"
          className="tes-control tes-control--no-height"
          placeholder="Our authors welcome feedback, both positive and negative as it all helps them get better. Please let them know what you think they are getting wrong."
          value={(review) ? review.comment : ''}
          onChange={(e) => this.onCommentChange(e.target.value)}
        />
        <div className="ResourceReviewsAdd-comment-cta text-right">
          <button disabled={this.state.lowReviewNoComment} type="submit" value="Post" onClick={() => this.onPostReview()} className="review-submit tes-btn tes-btn--primary tes-btn--md">
            Post
            {this.state.isPosting && <button type="button" className="tes-btn tes-btn--primary tes-btn--icon review_post_spinner">
              <i className="tes-btn__icon icon icon-spinner icon-white icon-spin"></i>
            </button>}
          </button>
        </div>
      </div> : null}
      {this.state.ratingSelectValue !== null && !this.state.reviewSubmited
        ? <div className={classnames({ 'mobile-view': mobile() }, 'resource-rating-reason-wrapper')}>
          <div className={classnames({ 'mobile-view': mobile() }, 'rating-reasons')}>
            {this.state.ratingSelectValue === true ? <h4>How would you describe it?</h4> : <div><h4>We're so sorry to hear that.</h4><h4>What went wrong?</h4></div>}
            {this.renderReviewReasons(resource)}
          </div>
          {this.state.showReviewDialog
            && <div className="rating-review">
              <div className="review-content">
                <h4>Do you want to leave a public review?</h4>
                <textarea placeholder="Write your comment here. It will be published and visible to all users." onChange={(e) => this.handleReviewChange(e.target.value)} />
              </div>
              <div className="review-buttons">
                <span className="submit-review" onClick={() => { this.onSubmitClick(); }}>Submit</span>
                {this.state.ratingSelectValue && <span className="cancel-review" onClick={() => { this.onSkipClick(); }}>Skip</span>}
                {!this.state.ratingSelectValue && <span className="cancel-review" onClick={() => { this.resetReviewState(); }}>Cancel</span>}
              </div>
            </div>
          }
          {this.state.showChoiceDialog
            && <div className={classnames({ 'mobile-view': mobile() }, 'rating-choice')}>
              <h3>You may also:</h3>
              <span className="choice-button" onClick={() => { this.setState({ showReviewDialog: true, showChoiceDialog: false }); }}>Leave a public review</span>
              <a href={`mailto:help@tes.com?subject=Technical issue with resource: ${resource.title} / ID:${resource._id}`}><span className="choice-button">Contact us</span></a>
              <span className="cancel-review" onClick={() => { this.onSkipClick(); }}>Skip</span>
            </div>
          }
        </div>
        : null}
      {this.state.reviewSubmited
        ? <div className="resource-rating-reason-wrapper">
          <div className={classnames({ 'mobile-view': mobile() }, 'rating-submited')}>
            <img src="data:image/svg+xml;base64,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" />
            <h2>Thanks for your feedback!</h2>
            <h4>Please, help other teachers by reviewing every purchased resource.</h4>
          </div>
        </div>
        : null}
    </div>;
  }
}

ReviewCard.propTypes = {
  cardLink: PropTypes.string,
  resource: PropTypes.object,
  setUserReview: PropTypes.func,
  emitReview: PropTypes.func,
  emitRating: PropTypes.func,
  submitReview: PropTypes.func,
  review: PropTypes.object,
  reviewReasons: PropTypes.arrayOf(PropTypes.object),
  setReviewDisplayState: PropTypes.func,
  setupResource: PropTypes.func,
  cancelUserReview: PropTypes.func,
  removeRecentReview: PropTypes.func,
  error: PropTypes.string,
  reviewDisplayStates: PropTypes.arrayOf(PropTypes.string),
  userReviews: PropTypes.object,
  isReviewMessageProfan: PropTypes.bool,
  setIsProfan: PropTypes.func,
};
